import React, { useEffect, useState } from "react";

const ProductBox = ({ product, comparehandler }) => {
  const addToCompare = () => {
    comparehandler(product.products);
  };

  if (product && product.products) {
    return (
      <div class="col-md-12">
        <figure
          class="figure product-box wow fadeIn animated"
          data-wow-delay="0ms"
          style={{ height: 700 }}
        >
          <div class="col-50">
            <div class="product-box-img">
              <a>
                <img
                  src={product.products[0].image}
                  class="prod-img"
                  alt="Product Img"
                />
              </a>
            </div>
            <figcaption class="figure-caption text-center">
              <div class="price-start">
                <h4 class="font-weight-500">{product.products[0].name}</h4>
                <h3 class="font-weight-500">
                  {product.products[0].company_name}
                </h3>
                <p class="font-weight-500 mar-bot-25">
                  {product.products[0].price}
                </p>
                <span class="font-weight-400">
                  <i class="fa fa-camera" aria-hidden="true"></i>{" "}
                  {product.products[0].productDetails.camera &&
                  product.products[0].productDetails.camera.front &&
                  product.products[0].productDetails.camera.front
                    ? product.products[0].productDetails.camera.front
                    : "N/A"}
                </span>
                <span class="font-weight-400">
                  <i
                    class="fa fa-battery-three-quarters"
                    aria-hidden="true"
                  ></i>
                  {product.products[0].productDetails.battery &&
                  product.products[0].productDetails.battery.capacity &&
                  product.products[0].productDetails.battery.capacity
                    ? product.products[0].productDetails.battery.capacity
                    : "N/A"}
                </span>
                <span class="font-weight-400">
                  <i class="fa fa-microchip" aria-hidden="true"></i>{" "}
                  {product.products[0].productDetails.processor &&
                  product.products[0].productDetails.processor.chipset &&
                  product.products[0].productDetails.processor.chipset
                    ? product.products[0].productDetails.processor.chipset
                    : "N/A"}
                </span>
              </div>
            </figcaption>
          </div>
          <div class="col-50">
            <div class="product-box-img">
              <a>
                <img
                  src={product.products[1].image}
                  class="prod-img"
                  alt="Product Img"
                />
              </a>
            </div>
            <figcaption class="figure-caption text-center">
              <div class="price-start">
                <h4 class="font-weight-500">{product.products[1].name}</h4>
                <h3 class="font-weight-500">
                  {product.products[1].company_name}
                </h3>
                <p class="font-weight-500 mar-bot-25">
                  {" "}
                  {product.products[1].price}
                </p>
                <span class="font-weight-400">
                  <i class="fa fa-camera" aria-hidden="true"></i>{" "}
                  {product.products[1].productDetails.camera &&
                  product.products[1].productDetails.camera.front &&
                  product.products[1].productDetails.camera.front
                    ? product.products[1].productDetails.camera.front
                    : "N/A"}
                </span>
                <span class="font-weight-400">
                  <i
                    class="fa fa-battery-three-quarters"
                    aria-hidden="true"
                  ></i>
                  {product.products[1].productDetails.battery &&
                  product.products[1].productDetails.battery.capacity &&
                  product.products[1].productDetails.battery.capacity
                    ? product.products[1].productDetails.battery.capacity
                    : "N/A"}
                </span>
                <span class="font-weight-400">
                  <i class="fa fa-microchip" aria-hidden="true"></i>{" "}
                  {product.products[1].productDetails.processor &&
                  product.products[1].productDetails.processor.chipset &&
                  product.products[1].productDetails.processor.chipset
                    ? product.products[1].productDetails.processor.chipset
                    : "N/A"}
                </span>
              </div>
            </figcaption>
          </div>
          <div
            class="compare-btn text-center col-12 mar-bot-25"
            onClick={() => addToCompare()}
          >
            <a class="btn btn-primary btn-sm" href="#">
              <i class="fa fa-exchange" aria-hidden="true"></i>
              Compare
            </a>
          </div>
        </figure>
      </div>
    );
  }
};

export default ProductBox;
